import tableStyles from 'src/Utils/CssModules/table.module.css';
import UserStorage from 'src/images/user-storage.png';
import UserStorageNotInse from 'src/images/user-storage-notInUse.png'
import { IClinicLicenseUserInfo, ILicenseStats } from "src/Utils/Hooks/ManageLicenses/useGetLicensesInfo";
import './LicenseInfo.css'
import { formatDateString, isValidDateTime } from "src/Utils/DateFormatting/DateFormattter";
import { useTranslation } from "react-i18next";
import MoreOptionsMenu from 'src/Components/MoreOptions/MoreOptions';
import ReleaseLicence from '../ReleaseLicence/ReleaseLicence';
import { InfoMessageType } from 'src/Components/InfoBar/InfoBar';
import React from 'react';
import { useClinicContext } from 'src/Utils/Hooks/ClinicContext';
import divStyles from 'src/Utils/CssModules/div.module.css';
import licenseKeyInUse from 'src/images/LicenseKeyInuse.svg';
import licenseKeyInNoUse from 'src/images/LicenseKeyInNoUse.svg'

interface ILicenseInfo {
    noOfUnusedLicenses: number;
    licensesList: IClinicLicenseUserInfo[];
    licenseEndDate: string;
    clinicId: string;
    setInfo: (message: string, type: InfoMessageType) => void;
    updatePageLoader: (load: boolean) => void;
    isSuiteLicense: boolean;
    licenseType?: string;
    licenseStatistics: ILicenseStats;
}
const LicenseInfo: React.FC<ILicenseInfo> = ({licensesList, noOfUnusedLicenses, licenseEndDate, clinicId, setInfo, updatePageLoader, isSuiteLicense, licenseType, licenseStatistics }) => {
    const {currentUser} = useClinicContext()
    const { t } = useTranslation();

    return (
        <>
            <div className='row mt-4'>
                <div className={`${tableStyles.fixTableHead} ${tableStyles.roundedTable} padding px-4`}>
                    <table style={{ width: '100%' }} data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                        <thead>
                            <tr>
                                <th className={`${tableStyles.heading} col-5 licenseType`}>
                                    {t('FloatingSeats')}  ({licenseStatistics?.inUse}/{licenseStatistics?.total} in use)
                                    {!isSuiteLicense ? 
                                        <span className='mx-2 entitlementId'>
                                            - {licenseType?.includes("Aura App") ? licenseType.replace("Aura App", "").trim() : licenseType}
                                        </span> : <></>
                                    }
                                </th>
                                <th className={tableStyles.heading}> </th>
                                <th style={{alignContent: 'center'}}>
                                    {   !isValidDateTime(licenseEndDate) && 
                                        <div className='d-flex justify-content-end'>
                                            <span>
                                                <button type="button" style={{width: '100%'}} className={`btn validity ${new Date(licenseEndDate) < new Date() ? 'expired' : ''}`}>
                                                    {`${t('ValidUnil')} ${formatDateString(licenseEndDate)}`}
                                                </button>
                                            </span>
                                        </div>
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                licensesList.map((item, index) =>
                                    <tr key={index}>
                                        <td className={tableStyles.data}>
                                            <span>
                                                <img src={isSuiteLicense ? UserStorage : licenseKeyInUse} className="key" alt="licenseKeyInUse" />
                                                {item.userEmail}
                                            </span>
                                        </td>
                                        <td className={tableStyles.data}>{item.appDeviceInfo}</td>
                                        <td>
                                            <div className={`d-flex justify-content-end ${!currentUser?.isClinicAdmin? divStyles.disabled : ''}`}>
                                                <MoreOptionsMenu id={'three-dots-licence-info'}>
                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                        <li>
                                                            <ReleaseLicence
                                                                clinicId={clinicId}
                                                                sessionId={item.sessionId}
                                                                setInfo={setInfo}
                                                                updatePageLoader={updatePageLoader} />
                                                        </li>
                                                    </ul>
                                                </MoreOptionsMenu>
                                            </div>

                                        </td>
                                    </tr>)
                            }
                            {Array.from({ length: noOfUnusedLicenses }).map((item, index) => (
                                <tr key={index}>
                                    <td className={tableStyles.data}>
                                        <span>
                                            <img src={isSuiteLicense ? UserStorageNotInse : licenseKeyInNoUse} className="key" alt="licenseKeyNotUsed" />
                                            {`(${t('NotInUse')})`}
                                        </span>
                                    </td>
                                    <td className={tableStyles.data}></td>
                                    <td>
                                        <div className='d-flex justify-content-end'>
                                            <MoreOptionsMenu disabled={true} children={null} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}
export default React.memo(LicenseInfo);